module.exports = __webpack_public_path__ + "img/do.09ba3588.svg";